import { Language } from '../core/models/language.model';

export class User {
   Id = '';
   Name = '';
   Email = '';
   CellPhone = '';
   DocumentNumber = '';
   BirthDate = '';
   PhotoUrl = 'assets/images/avatars/user.png';
   MemberSince = '';
   Language: Language = new Language();
}

export interface UpdateUser {
   Name: string;
   CellPhone: string;
   Email: string;
   DocumentNumber: string;
   Photo?: string;
}

export interface UserAddress {
   Id: string;
   StreetName: string;
   StreetNumber: string;
   Complement: string;
   Neighborhood: string;
   PostalCode: string;
   City: string;
   State: string;
   Country: string;
   IsFavorite: boolean;
}
